export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "Gifting Service",
  headline: "😍A Hone For Needy! 😍A Hobbie For Patron!",
  description:
    "We Serve Medium Between Needy and Patron, For Fulfill Their Desired Respective Needs !😋",
  buttonLabel: "Get Started",
  imgStart: "",
  img: "https://raw.githubusercontent.com/prerit2001/Gifter/master/Images/%E2%80%94Pngtree%E2%80%94exquisite%20blue%20christmas%20bow%20gift_5532670.png",
  alt: "Gift",
  start: "",
};

export const homeObjTwo = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: "Why Us ? 🤔",
  headline: "🤗 Our Purpose 🎁",
  description:
    "In our personal life, We all want something to have with us which we want as a gift or present. We have no choice other than hoping for that present. Also, we get confused about what to take as a gift with us when visiting other`s homes/parties, etc. This Platform Solves both issues. As a Hoper You can add your wishlist of the item you want as your present and as a visiter you can check for a visiting person profile wishlist earlier.",
  buttonLabel: "Wish Dream 🎁",
  imgStart: "start",
  img: "https://raw.githubusercontent.com/debugcluster1/kjhuh/master/%E2%80%94Pngtree%E2%80%94christmas%20gifts%20winter%20happy%20children_3966009.png",
  alt: "Gift",
  start: "true",
};

export const homeObjthree = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "Gifting Service",
  headline: "😍A Hone For Needy! 😍A Hobbie For Patron!",
  description:
    "We Serve Medium Between Needy and Patron, For Fulfill Their Desired Respective Needs !😋",
  buttonLabel: "Get Started",
  imgStart: "",
  img: "https://raw.githubusercontent.com/prerit2001/Gifter/master/Images/%E2%80%94Pngtree%E2%80%94exquisite%20blue%20christmas%20bow%20gift_5532670.png",
  alt: "Gift",
  start: "",
};

export const homeObjFour = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: "Let Your Dream Comes True! 🥳",
  headline: "🤗 Do You Have Account For Your Wishes ? 🔐",
  description:
    "Don`t have account ? Sign up ! 　　　　　　　　　 Already have account ? Sign in ! 　　　　　　　　　CLICK 👇",
  buttonLabel: "CLICK HERE",
  imgStart: "start",
  img: "https://raw.githubusercontent.com/debugcluster1/kjhuh/master/%E2%80%94Pngtree%E2%80%94log%20in%20login%20interface%20computer_3945571.png",
  alt: "Gift",
  start: "true",
};
